import Backbone from 'backbone';
import $ from 'jquery';

import * as analytics from 'analytics/Analytics';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as ladders from 'molbio/virtual-digests/Ladders';
import notifications from 'notifications';
import OwnablesManageView, {OwnablesManageViewOptions} from 'profile/OwnablesManageView';
import {BasicEvent} from 'util/Types';

class LadderContentView extends Backbone.View<ladders.Model> {
  parsedBands!: Array<number>;

  static initClass(): void {
    this.prototype.el = '.ladder-bands-view';
    this.prototype.events = {
      // @ts-expect-error: Backbone events can be either the events hash or a method returning the events hash
      // The Backbone types do not know about this.
      'input .ladder-bands': 'parseBands',
    };
  }

  override initialize(): void {
    this.parsedBands = [];
  }

  die(): void {
    this.stopListening();
    this.undelegateEvents();
  }

  update(ladder: ladders.Model): void {
    this.parsedBands = ladder.bandSizes();
    this.$('.ladder-bands')
      .val(this.parsedBands.join('\n'))
      .attr({disabled: !ladder.get('permissions').writable});
    this.updatePreview();
  }

  parseBands(e: BasicEvent): void {
    const bandText = ($(e.currentTarget).val() as string).split('\n');
    const result: Array<number> = [];
    for (const text of bandText) {
      const parsed = parseInt(text, 10);
      if (!Number.isNaN(parsed)) {
        result.push(parsed);
      }
    }
    this.parsedBands = result;
    this.parsedBands.sort((a, b) => b - a);
    this.updatePreview();
  }

  updatePreview(): void {
    this.$('.preview').html(this.parsedBands.join('<br>'));
  }

  bands(): Array<number> {
    return this.parsedBands;
  }
}
LadderContentView.initClass();

let laddersCollection: ladders.Collection | null = null;

class LaddersView extends OwnablesManageView<ladders.Model> {
  type!: string;
  modelType!: string;
  ladderContent!: LadderContentView;
  ownables!: ladders.Collection;

  static initClass(): void {
    this.prototype.el = '.js-ladders';
    this.prototype.type = 'ladders';
    this.prototype.modelType = ModelTypeConstants.LADDER;
  }

  override events(): Backbone.EventsHash {
    return {
      ...super.events(),
      'submit .create-new form': 'createNewLadder',
      'click .save-bands': 'saveBands',
    };
  }

  static getBootstrappedOwnables(): ladders.Collection {
    if (laddersCollection == null) {
      laddersCollection = new ladders.Collection(window.bootstrap!.ladders);
    }
    return laddersCollection;
  }

  override initialize(options: OwnablesManageViewOptions<ladders.Model>): void {
    this.ladderContent = new LadderContentView();
    super.initialize(options);
  }

  override die(): void {
    super.die();
    this.ladderContent.die();
  }

  saveBands(e: BasicEvent): void {
    const $target = $(e.currentTarget);
    $target.button('loading');
    this.currentOwnable
      .save(
        {band_sizes: this.ladderContent.bands()},
        {patch: true, url: `${this.currentOwnable.url()}/attributes`}
      )
      .fail(notifications.notifyError)
      .done(() => {
        notifications.success('Ladder successfully saved.');
        $target.button('reset');
      });
  }

  createNewLadder(e: BasicEvent): void {
    e.preventDefault();
    const ladder = new ladders.Model({
      name: this.$el.find('.create-new .name').val() as string,
      description: this.$el.find('.create-new .description').val() as string,
      owner_id: window.bootstrap!.current_entity_id,
    });
    ladder
      .save()
      .fail(notifications.notifyError)
      .done(() => {
        this.$el.find('.create-new .name, .create-new .description').val('');
        this.ownables.add(ladder);
        this.navigateToOwnable(ladder.id);
        notifications.success('Ladder created successfully!');
        analytics.track('DATA_MANAGEMENT', 'created_ownable', {
          type: this.type,
          name: ladder.get('name'),
          has_description: (ladder.get('description') ?? '').length > 0,
        });
      });
  }

  override renderOwnable(): void {
    super.renderOwnable();
    const list = this.currentOwnable;
    this.ladderContent.update(list);
    const {writable} = list.get('permissions');
    this.$('.writable-instructions, .save-bands').toggleClass('hidden', !writable);
    this.$('.readable-instructions').toggleClass('hidden', writable);
    $.getJSON(`/1/api/ladders/${list.id}/collaborators/`)
      .done((res) => {
        this.createCollaboratorsView(res);
      })
      .fail(notifications.notifyError);
  }
}
LaddersView.initClass();

export default LaddersView;
